import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }